"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _default = {
  PropTypes: {
    label: _propTypes.default.string,
    code: _propTypes.default.string,
    selectionType: _propTypes.default.string,
    theme: _propTypes.default.string,
    onSelectionDone: _propTypes.default.func,
    displaySelected: _propTypes.default.string
  },
  DefaultProps: {}
};
exports.default = _default;